import { styled, Typography } from "@mui/material";
import NoData from "assets/images/NoData.png";
import ErrorImg from "assets/images/Error.png";
import ErrorCollecting from "assets/images/ErrorCollecting.png";
import Collecting from "assets/images/Collecting.png";

const ContainerStyled = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  "&.big": {
    width: "60%",
    [theme.breakpoints.down("md")]: {
      width: "90%",
    },
  },
}));

const Error = ({ type, message }) => {
  if (type === "collecting")
    return (
      <ContainerStyled>
        <img src={Collecting} alt="collecting" />
        <Typography textAlign="center">
          {message ?? "Αυτήν την στιγμή συλλέγουμε τα δεδομένα σας"}
        </Typography>
      </ContainerStyled>
    );
  if (type === "missing")
    return (
      <ContainerStyled>
        <img src={NoData} alt="no data" />
        <Typography textAlign="center">Δεν υπάρχουν δεδομένα</Typography>
      </ContainerStyled>
    );
  if (type === "missingBig")
    return (
      <ContainerStyled className="big">
        <img src={ErrorCollecting} alt="error collecting" />
        <Typography textAlign="center">Δεν υπάρχουν δεδομένα</Typography>
      </ContainerStyled>
    );
  if (type === "error")
    return (
      <ContainerStyled className="big">
        <img src={ErrorImg} alt="error" />
        <Typography textAlign="center">
          {message ?? "Δεν υπάρχουν δεδομένα"}
        </Typography>
      </ContainerStyled>
    );
};

export default Error;
